import {
  ChatChannel,
  ChatChannelSortableFieldEnum,
  SortDirectionEnum,
} from "@/__generated__/graphql";
import { CHAT_CHANNELS_QUERY } from "@/api/queries/chatChannels";
import { useQuery } from "@apollo/client";

interface ChatChangesVariables {
  orgId?: string;
  hasBeenUsedForLiveEvent?: boolean;
}

export function useChatChannels(variables: ChatChangesVariables) {
  const { data, loading, error } = useQuery(CHAT_CHANNELS_QUERY, {
    variables: {
      orgId: variables?.orgId ?? "",
      hasBeenUsedForLiveEvent: variables?.hasBeenUsedForLiveEvent,
      ordering: {
        direction: SortDirectionEnum.Asc,
        field: ChatChannelSortableFieldEnum.DisplayName,
      },
    },
    skip: !variables?.orgId,
  });

  const processedData =
    data?.node?.__typename === "Organization"
      ? data.node.chatChannels?.edges
          ?.filter((edge) => edge?.__typename === "ChatChannelEdge")
          ?.filter(
            (edge): edge is { cursor: string; node: ChatChannel } =>
              edge?.node !== null,
          )
          .map((edge) => edge.node)
      : [];

  return {
    data: processedData,
    loading,
    error,
  };
}
